<lib-insta-learn-posts-widget 
  [title]="data?.subTitle"
  [description]="data.text"
  [textColor]="data.defaultTextColor"
  [appendPlaceholders]="true"
  [items]="items"
  [animation]="data?.animation"
  [animationDelay]="data?.animationDelay"
  (openDialog)="openDialog($event)"
  (navigate)="navigate($event)">
</lib-insta-learn-posts-widget>